var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"device-info"},[_c('FormRow',{attrs:{"label":"Device Model","input-payload":_vm.model,"static-field":true}}),_c('FormRow',{attrs:{"label":"Config Version","input-payload":_vm.version,"static-field":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }